import { render } from "./ListeFilierePage.vue?vue&type=template&id=0b29aaf2&ts=true"
import script from "./ListeFilierePage.vue?vue&type=script&lang=ts"
export * from "./ListeFilierePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__